<div id="assign-modal">
    <div class="modal-header">
        <h2 class="title">
            <app-icon type="AssignClass" class="assign-class-icon"></app-icon>Assign to Class
        </h2>
        <button
            *ngIf="activeModal"
            type="button"
            class="close"
            aria-label="Close"
            (click)="closeModal()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ng-container *ngIf="step === 1">
            <app-select-class-view
                [activeModal]="activeModal"
                [rosters]="rosters"
                (step)="stepChange($event)"
            ></app-select-class-view>
        </ng-container>
        <ng-container *ngIf="step === 2">
            <app-select-student-view
                [rosters]="rosters"
                (step)="stepChange($event)"
            ></app-select-student-view>
        </ng-container>
        <ng-container *ngIf="step === 3">
            <app-loading-view
                [loading]="loading"
                [error]="error"
                (resendRequest)="resendRequest($event)"
            ></app-loading-view>
        </ng-container>
        <ng-container *ngIf="step === 4">
            <app-review-assignments-view
                [activeModal]="activeModal"
                [activityData]="activityData"
                [rosters]="rosters"
            ></app-review-assignments-view>
        </ng-container>
    </div>
</div>
